module.exports = __webpack_public_path__ + "static/media/singaporeRound.4b562345.svg";